import { NgModule, ModuleWithProviders, SkipSelf, Optional, NgModuleRef, InjectionToken } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ApiConfigManager, ApiConfigOptions, ModuleSourceInfo } from '@sg/api/base-api-lib';
import { ClientIntegrationApiClient } from './services';
import { ClientIntegrationApiConfig } from './api-config';

declare module '../../../base-api-lib/src/lib/api-config-manager' {
  interface ApiConfigOptionsStore {
    clientIntegrationApiConfig?: ApiConfigOptions;
  }
  interface ApiConfigManager {
    clientIntegrationApiConfig: ClientIntegrationApiConfig;
  }
}

export const CONFIG_FACTORY_TOKEN = new InjectionToken('ClientIntegrationApiModule Config Factory');

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [ClientIntegrationApiClient],
})
export class ClientIntegrationApiModule {
  public static forRoot(
    configFactory?: (cfgMgr?: ApiConfigManager) => ClientIntegrationApiConfig
  ): ModuleWithProviders<ClientIntegrationApiModule> {
    return {
      ngModule: ClientIntegrationApiModule,
      providers: [{ provide: CONFIG_FACTORY_TOKEN, useValue: configFactory }],
    };
  }

  constructor(
    cfgMgr: ApiConfigManager,
    moduleRef: NgModuleRef<any>,
    @Optional() @SkipSelf() parentModule: ClientIntegrationApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ClientIntegrationApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }

    const configFactory: (cfgMgr?: ApiConfigManager) => ClientIntegrationApiConfig =
      moduleRef.injector.get<any>(CONFIG_FACTORY_TOKEN);
    const config = configFactory
      ? configFactory(cfgMgr)
      : new ClientIntegrationApiConfig(cfgMgr.withBase(cfgMgr.getRawConfig('clientIntegrationApiConfig')));
    cfgMgr.addApiConfig('clientIntegrationApiConfig', config);
  }
}
